import { ReactNode } from "react";

export class MenuConfigModel {
  constructor(
    public name: string | ReactNode,
    public path: string,
    public componentName: string,
    public icon: ReactNode | any,
    public subMenu: MenuConfigModel[] = []
  ) {}
}

export class SidebarConfigModel {
  constructor(public menu: MenuConfigModel[]) {}
}
